'use strict';

function clockService($interval) {
  var secPassed = 0;
  var interval = null;
  var intervalFunc = null;
  var repeatSeconds = 0;

  return {
    start: start,
    stop: stop,
    reset: reset,
    restart: restart,
    getSecondsPassed: getSecondsPassed,
    getMinutesPassed: getMinutesPassed,
    setIntervalFunction: setIntervalFunction
  };

  function start() {
    var tick = function() {
      secPassed++;
      // execture the interval function every 'repeatSeconds' second
      if (intervalFunc && secPassed % repeatSeconds === 0) {
        intervalFunc();
      }
    };
    tick();
    interval = $interval(tick, 1000);
  }

  function stop() {
    $interval.cancel(interval);
    interval = null;
  }

  function reset() {
    stop();
    secPassed = 0;
  }

  function restart() {
    reset();
    start();
  }

  function setIntervalFunction(func, repeat) {
    intervalFunc = func;
    repeatSeconds = repeat || 1;
  }

  function getSecondsPassed() {
    return secPassed;
  }

  function getMinutesPassed() {
    return parseInt(secPassed / 60);
  }
}

module.exports = clockService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/services/clock.service.js
 ** module id = 316
 ** module chunks = 0
 **/